export class PhoneNumberModel {
    number: string;
    id: number | undefined;
    primary: boolean;
}